export interface ITaskTypePrintHtml {
    html: string;
}

export class TaskTypePrintHtml implements ITaskTypePrintHtml {
    html: string;

    constructor();
    constructor(obj: ITaskTypePrintHtml);
    constructor(obj?: any) {
        this.html = obj && obj.html || "";
    }
}